import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

export interface HttpErrorContext {
  url?: string | null;
  method?: string;
  status?: number;
  apiType?: string;
}

@Injectable({ providedIn: 'root' })
export class LoggingService {
  logHttpError(error: unknown, context: HttpErrorContext): void {
    if (!environment.production) {
      console.error('[HTTP Error]', context, error);
      return;
    }

    this.reportToRemote(error, context);
  }

  private reportToRemote(error: unknown, context: HttpErrorContext): void {
    void error;
    void context;
    // TODO: wire up Sentry or a custom logging endpoint.
  }
}
